import { Grid, Typography } from "@mui/material";
import styles from "./toast.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState, useRef, useEffect } from 'react';
import toast from "react-hot-toast";

interface ToastSuccessProps {
  defaultMessage?: string;
  message?: string;
  sent?: string;
}

const ToastSuccess: React.FC<ToastSuccessProps> = ({
  defaultMessage = "",
  sent = "",
  message,
}) => {
  const successtoastclose = useRef<HTMLDivElement>(null);
  const handleClose = () => {
    toast.remove();
  };

  useEffect(() => {
    window.scroll(0, 200)
  }, [])
  useEffect(() => {
    function handleClickOutside(event: any) {
       if (successtoastclose.current && !successtoastclose.current.contains(event.target)) {
        toast.remove();
       }
    }
    window.addEventListener('click', handleClickOutside);
  }, []);
  
  return (
    <>
      {(
        <div className={styles.totalLayoutSuccess} ref={successtoastclose}>
          <Grid className={styles.sublayout}>
            <div>
              <img src="/images/successIcon.svg" style={{margin:"auto"}}/>
            </div>
            <div style={{maxWidth: "300px", marginRight: "5px", marginLeft: "5px", display: "flex", flexDirection: "row", justifyContent: "center", height:"auto" }}>
              <Typography className={styles.sent}>
                {message} {""}
              </Typography>
              {/* <Typography className={styles.sentsuccess}>
                {message || defaultMessage}
              </Typography> */}
              <div style={{ marginLeft: "12px" }}>
                <CloseIcon onClick={handleClose} sx={{ maxWidth: "30px", height: "20px", cursor: "pointer", marginTop:"5px" }} />
              </div>
            </div>
          </Grid>
        </div>
      )}
    </>
  );
};

export default ToastSuccess;
